import TurndownService from 'turndown';

import { htmlTags } from './html-tags';

const excludeTags = ['pre', 'code'];

const turndownService = new TurndownService({ codeBlockStyle: 'fenced', fence: '```' });

const filterTags = htmlTags.filter((item) => !excludeTags.includes(item));

/**
 * Custom rule
 * https://github.com/mixmark-io/turndown/issues/241#issuecomment-400591362
 */
turndownService.addRule('keep', {
  filter: filterTags,
  replacement(content: string, node: any) {
    const { isBlock, outerHTML } = node;

    return node && isBlock ? `\n\n${outerHTML}\n\n` : outerHTML;
  },
});

// ----------------------------------------------------------------------

export function htmlToMarkdown(html: string) {
  return turndownService.turndown(html);
}
// ----------------------------------------------------------------------

/**
 * 마크다운으로 볼 것인가 — 아니면 HTML 로 보고 `htmlToMarkdown` 으로 옮긴다.
 *
 * ⚠️ 줄머리 표식(`#` · `-` · `|` · ```` ``` ````)은 **여러 줄 모드(`m`)로 찾는다** — 첫 줄이 평범한 문장인
 * 글(예: AI 답변)은 `^` 만으로는 못 찾아 HTML 로 잘못 보고, 변환 과정에서 **줄바꿈이 통째로 뭉개진다.**
 */
export function isMarkdownContent(content: string) {
  // Checking if the content contains Markdown-specific patterns
  const markdownPatterns = [
    /* Heading */
    /^#+\s/m,
    /* List item */
    /^(\*|-|\d+\.)\s/m,
    /* Code block */
    /^```/m,
    /* Table */
    /^\|/m,
    /* Unordered list */
    /^(\s*)[*+-] [^\r\n]+/m,
    /* Ordered list */
    /^(\s*)\d+\. [^\r\n]+/m,
    /* Image */
    /!\[.*?\]\(.*?\)/,
    /* Link */
    /\[.*?\]\(.*?\)/,
  ];

  // Checking if any of the patterns match
  return markdownPatterns.some((pattern) => pattern.test(content));
}
